var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCategorias(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.112,
    height: 11.5,
    viewBox: "0 0 17.112 11.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_147ba8c6548c9a08500ec8755a2ac705",
    "data-name": "147ba8c6548c9a08500ec8755a2ac705",
    transform: "translate(-10 -170.7)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_558",
    "data-name": "Caminho 558",
    d: "M10,172.02a1.32,1.32,0,0,0,2.64,0h0a1.32,1.32,0,0,0-2.64,0Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_559",
    "data-name": "Caminho 559",
    d: "M261.9,173.34H251.62a1.325,1.325,0,0,1-1.32-1.32h0a1.325,1.325,0,0,1,1.32-1.32H261.9a1.325,1.325,0,0,1,1.32,1.32h0A1.325,1.325,0,0,1,261.9,173.34Z",
    transform: "translate(-236.104)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_560",
    "data-name": "Caminho 560",
    d: "M10,425.72a1.32,1.32,0,1,0,1.32-1.32A1.32,1.32,0,0,0,10,425.72Z",
    transform: "translate(0 -249.27)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_561",
    "data-name": "Caminho 561",
    d: "M261.9,427.04H251.62a1.325,1.325,0,0,1-1.32-1.32h0a1.325,1.325,0,0,1,1.32-1.32H261.9a1.325,1.325,0,0,1,1.32,1.32h0A1.325,1.325,0,0,1,261.9,427.04Z",
    transform: "translate(-236.104 -249.27)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_562",
    "data-name": "Caminho 562",
    d: "M10,679.32a1.32,1.32,0,0,0,2.64,0h0a1.32,1.32,0,0,0-2.64,0Z",
    transform: "translate(0 -498.442)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_563",
    "data-name": "Caminho 563",
    d: "M261.9,680.74H251.62a1.325,1.325,0,0,1-1.32-1.32h0a1.325,1.325,0,0,1,1.32-1.32H261.9a1.325,1.325,0,0,1,1.32,1.32h0A1.325,1.325,0,0,1,261.9,680.74Z",
    transform: "translate(-236.104 -498.54)",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCategorias);
export default __webpack_public_path__ + "static/media/Categorias.20763d2f8b5833825c0b6faae49054d4.svg";
export { ForwardRef as ReactComponent };